module.exports = __webpack_public_path__ + "img/solver.1a63f1ee.jpg";